module.exports = __webpack_public_path__ + "static/media/HP-LoginImage-@1x.b10f3a0e.png";